import { Route, Routes } from "react-router-dom";
import PaymentListView from "../../newComponents/payments/PaymentList";
import AddPayment from "../../newComponents/payments/AddPayment";
import PayablesPostPayment from "../../newComponents/payments/PayablesPostPayment";
import ReceivablesPostPayment from "../../newComponents/payments/ReceivablesPostPayment";
import PaymentDetails from "../../newComponents/payments/PaymentDetails/PaymentDetails";
import EditPayable from "../../newComponents/payments/EditPayable";
import EditReceivable from "../../newComponents/payments/EditReceivable";
import { PermissionGuard } from "../../newComponents/PermissionGuard";
import { AccessLevelEnum } from "@propertelligent/client-api";
import NoAccess from "../NoAccess";

const Payments = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <PermissionGuard
            permission="Payments"
            level={AccessLevelEnum.ReadOnly}
            fallback={<NoAccess />}
          >
            <PaymentListView />
          </PermissionGuard>
        }
      />
      <Route
        path="/settle-payables-payment/:id"
        element={
          <PermissionGuard
            permission="Payments"
            level={AccessLevelEnum.All}
            fallback={<NoAccess />}
          >
            <PayablesPostPayment />
          </PermissionGuard>
        }
      />
      <Route
        path="/settle-receivables-payment/:id"
        element={
          <PermissionGuard
            permission="Payments"
            level={AccessLevelEnum.All}
            fallback={<NoAccess />}
          >
            <ReceivablesPostPayment />
          </PermissionGuard>
        }
      />
      <Route
        path="/create"
        element={
          <PermissionGuard
            permission="Payments"
            level={AccessLevelEnum.All}
            fallback={<NoAccess />}
          >
            <AddPayment />
          </PermissionGuard>
        }
      />
      <Route
        path="/edit-payable/:id"
        element={
          <PermissionGuard
            permission="Payments"
            level={AccessLevelEnum.All}
            fallback={<NoAccess />}
          >
            <EditPayable />
          </PermissionGuard>
        }
      />
      <Route
        path="/edit-receivable/:id"
        element={
          <PermissionGuard
            permission="Payments"
            level={AccessLevelEnum.All}
            fallback={<NoAccess />}
          >
            <EditReceivable />
          </PermissionGuard>
        }
      />
      <Route
        path="/paymentdetails/:id"
        element={
          <PermissionGuard
            permission="Payments"
            level={AccessLevelEnum.ReadOnly}
            fallback={<NoAccess />}
          >
            <PaymentDetails />
          </PermissionGuard>
        }
      />
    </Routes>
  );
};



export default Payments;